import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
    selector: 'expense-id-rollback-renderer',
    templateUrl: './expense-id-rollback-renderer.component.html',
    standalone: false
})
export class ExpenseIdRollbackRendererComponent implements ICellRendererAngularComp {
  expenseId: any;
  isRecalledExpense: boolean;

  initilize(params: ICellRendererParams) {
    this.expenseId = params.getValue();
    this.isRecalledExpense = params.data?.isRecalledExpense;
  }

  agInit(params: any): void {
    this.initilize(params);
  }

  refresh(params: any): boolean {
    this.initilize(params);
    return true;
  }
}
